import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import signature from '../Images/signature.png'
import padecHeader from '../Images/padec-header.jpg'

// --- STYLED COMPONENTS ---

const PageContainer = styled.section`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  color: #333333;
  line-height: 1.6;
`;

// Top Circled Image Container (Banner/Logo space)
const TopBannerContainer = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto 10px auto;
  min-height: 120px;
//   border: 2px dashed #439E6D; /* Visual indicator for your image slot */
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

const PolicyTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #439E6D; /* Using your specified theme color */
  text-align: center;
  text-transform: uppercase;
//   margin-bottom: 35px;
  letter-spacing: 0.5px;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  text-align: justify;
  margin-bottom: 20px;
  color: #334155;
`;

const ListIntro = styled.p`
  font-size: 0.95rem;
  font-weight: 600;
  color: #0c2340;
//   margin-bottom: 15px;
`;

const BulletList = styled.ul`
  list-style-type: none;
  padding-left: 0;
//   margin-bottom: 30px;
`;

const BulletItem = styled.li`
  font-size: 0.95rem;
  color: #334155;
//   margin-bottom: 12px;
  position: relative;
  padding-left: 25px;
  text-align: justify;

  &::before {
    content: "•";
    color: #439E6D; /* Theme matched bullet points */
    font-weight: bold;
    font-size: 1.4rem;
    position: absolute;
    left: 5px;
    top: -4px;
  }
`;

const FooterSignOff = styled.div`
//   margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

// Bottom Circled Image Container (Signature space)
const SignatureSlot = styled.div`
//   width: 250px;
  min-height: 80px;
  border: 2px dashed #439E6D; /* Visual indicator for your signature slot */
  border-radius: 4px;
//   margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;

  img {
    max-width: 100%;
    max-height: 80px;
    object-fit: contain;
  }
`;

const SigneeName = styled.h4`
  font-size: 1.05rem;
  font-weight: 600;
  color: #0c2340;
  margin: 0 0 4px 0;
`;

const SigneeRole = styled.span`
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
  margin-bottom: 25px;
`;

const OwnershipStatement = styled.p`
  font-size: 1rem;
  font-weight: 700;
  color: #0c2340;
  text-align: center;
//   margin-top: 20px;
  border-top: 1px solid #e2e8f0;
//   padding-top: 25px;
`;

// --- MAIN COMPONENT ---

const NigerianContentPolicy = () => {
  return (
    <PageContainer>
      
      {/* Top Image Slot (Circled Red in header) */}
      <Fade triggerOnce direction="up" duration={800}>
        <TopBannerContainer>
          {/* Replace src with your header graphic/logo when ready */}
          <img src={padecHeader} alt="Nigerian Content Header Asset" onError={(e) => e.target.style.display='none'} />
          {/* <span style={{color: '#94a3b8', fontSize: '0.9rem'}}>Header Image Space</span> */}
        </TopBannerContainer>
      </Fade>

      {/* Title */}
      <Fade triggerOnce direction="up" duration={800} delay={100}>
        <PolicyTitle>NIGERIAN CONTENT POLICY STATEMENT</PolicyTitle>
      </Fade>

      {/* Policy Context paragraphs */}
      <Fade triggerOnce direction="up" duration={800} delay={150}>
        <Paragraph>
          PADEC GLOBAL SERVICES LIMITED shall comply with the Nigerian Content Development Policy directive as provided for in Nigerian Oil and Gas Industry Content Development Act (NOGICD Act 2010) on local content materials, suppliers and manpower from Nigeria and make use of services which are rendered by Nigerians or Companies incorporated in Nigeria, except when after proper research, such services/facilities are not available in Nigeria.
        </Paragraph>
        <Paragraph>
          PADEC shall seek to maximize the involvement of Nigerian manpower, businesses and local contractors in its survey operations in compliance with the Act.
        </Paragraph>
        
        <ListIntro>PADEC shall,</ListIntro>
      </Fade>

      {/* Bullet Items */}
      <BulletList>
        <Fade triggerOnce cascade direction="up" duration={600} fraction={0.1} damping={0.15}>
          <BulletItem>
            Train Surveyors, Engineers, skilled and unskilled workers during execution of survey projects.
          </BulletItem>
          <BulletItem>
            Invest in the development training of Nigerians to participate in higher level offshore surveys.
          </BulletItem>
          <BulletItem>
            Ensure adherence to Project specific Local content plan.
          </BulletItem>
          <BulletItem>
            Expose many Nigerian surveyors, ICT professionals and engineers to new survey and mapping technologies.
          </BulletItem>
        </Fade>
      </BulletList>

      {/* Closing Responsibility Paragraph */}
      <Fade triggerOnce direction="up" duration={800}>
        <Paragraph>
          It shall be the responsibility of the Managing Director and NCD Co-ordinator to ensure the reinforcement of the policy. PADEC Management and the entire workforce shall work to ensure full implementation at all time and abide by the policy.
        </Paragraph>
      </Fade>

      {/* Sign-off & Signature Slot (Circled Red at bottom) */}
      <Fade triggerOnce direction="up" duration={800} delay={100}>
        <FooterSignOff>
          <SignatureSlot>
            {/* Replace src with your scanned signature image path */}
            <img src={signature} alt="Managing Director Signature" onError={(e) => e.target.style.display='none'} />
            {/* <span style={{color: '#94a3b8', fontSize: '0.85rem'}}>Signature Image Space</span> */}
          </SignatureSlot>
          
          <SigneeName>Surv/Engr. Patrick Chigere</SigneeName>
          <SigneeRole>Managing Director</SigneeRole>
        </FooterSignOff>
      </Fade>

      {/* Final 100% Ownership Footer Text */}
      <Fade triggerOnce direction="up" duration={800} delay={150}>
        <OwnershipStatement>
          Padec Global Services limited is 100% owned by Nigerian and presently all the workers are Nigerians.
        </OwnershipStatement>
      </Fade>

    </PageContainer>
  );
};

export default NigerianContentPolicy;